import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { ListChannelFlowsRequestFilterSensitiveLog, ListChannelFlowsResponseFilterSensitiveLog, } from "../models/models_0";
import { de_ListChannelFlowsCommand, se_ListChannelFlowsCommand } from "../protocols/Aws_restJson1";
export { $Command };
export class ListChannelFlowsCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("ChimeMessagingService", "ListChannelFlows", {})
    .n("ChimeSDKMessagingClient", "ListChannelFlowsCommand")
    .f(ListChannelFlowsRequestFilterSensitiveLog, ListChannelFlowsResponseFilterSensitiveLog)
    .ser(se_ListChannelFlowsCommand)
    .de(de_ListChannelFlowsCommand)
    .build() {
}
